import { useEffect, useState } from "react";
import DataTable from "../../component/DataTable";
import { Link } from "react-router-dom";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints"; 
import { toast } from "react-toastify";
import AdminHeader from "../../component/AdminHeader";

const newsDeleteEndpoint = ApiEndpoints.news.newsDelete;
const newsListEndpoint = ApiEndpoints.news.newsList;
const newsEditPath = "edit-news";
const tableHeader = ["Date", "Title", "Media Category", "News Type", "Source", "Slug"];
const tbody = ["date", "title", "media_category_name", "news_type", "source", "slug"];

export default function NewsListing() {

  const [data, setData] = useState([]);

  const dataFetch = async () => {
    try {
      const response = await ApiRequest("GET", newsListEndpoint);
      setData(response?.news || []);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => { 
    dataFetch();
  }, []);

  const handleDelete = async (news_id) => {
    const payload = { news_id };
    try {
      const response = await ApiRequest("POST", newsDeleteEndpoint, payload);
      response.error ? toast.error(response.message) : toast.success(response.message);
      dataFetch();
    } catch (error) {
      toast.error(error.response?.data?.message || "Unable to delete news.");
    }
  };

  const pagename = {
    name: 'Media Management',
    user: 'Admin',
    innerpage: 'Media Management / News'
  }

  return (
    <>
    <AdminHeader pagename={pagename}/>

    <div className="add-btn-section">
      <Link className="admin-add-btn" to="/add-news">Add +</Link>
      <DataTable
        data={data}
        tableHeader={tableHeader}
        tbody={tbody}
        editPath={newsEditPath}
        onDelete={handleDelete}
      />
    </div>
    </>
  )
}
